import { useGetSubtotalWithPromoCode } from '../../../modules/promoCodes'
import { type PromoCode } from '../../../modules/promoCodes'
import { type QuoteAlternativeDate } from '../../../modules/quotes/core/models/subModels/alternativeDate.model'
import { type QuoteJob } from '../../../modules/quotes/core/models/subModels/quoteJob.model'
import { mergeClassName } from '../../../utils/mergeClassName'
import { useQuoteContext } from '../QuoteComponent.context'
import DateBox from './DateBox'

type AlternativeDateProps = {
  job: QuoteJob
  alternativeDate: QuoteAlternativeDate
  promoCode?: PromoCode
}

const AlternativeDate: React.FC<AlternativeDateProps> = ({
  job,
  alternativeDate,
  promoCode,
}) => {
  const { onAlternativeDateClick, presentationMode } = useQuoteContext()
  const priceWithPromoCode = useGetSubtotalWithPromoCode()
  const date = new Date(alternativeDate.date)

  const basePrice = priceWithPromoCode(job.subtotal, promoCode)
  const alternativePrice = priceWithPromoCode(alternativeDate.subtotal, promoCode)
  const clickable = onAlternativeDateClick && alternativeDate.dateAvailable && !presentationMode

  const getClassName = () => {
    if (!alternativeDate.dateAvailable) {
      return 'bg-red-300 opacity-90 hidden md:block'
    }
    if (alternativePrice.price < basePrice.price) {
      return 'bg-green-200'
    }

    if (alternativePrice.price > basePrice.price) {
      return 'bg-red-100'
    }
    return 'hidden md:block'
  }

  return (
    <DateBox
      key={date.getTime()}
      date={date}
      price={alternativePrice}
      className={mergeClassName(
        getClassName(),
        'cursor-default',
        clickable && 'cursor-pointer hover:ring-2 ring-slate-500',
      )}
      floatingNode={!alternativeDate.dateAvailable && (
        <div className="before:absolute before:left-[30%] before:top-[-30%] before:h-[200%] before:w-px before:rotate-45 before:bg-red-400 before:content-[''] after:absolute after:right-[30%] after:top-[-30%] after:h-[200%] after:w-px after:-rotate-45 after:bg-red-400 after:content-['']" />
      )}
      onClick={clickable ? () => { onAlternativeDateClick(job.jobId, alternativeDate) } : undefined}
    />
  )
}

export default AlternativeDate
